<template>
	<v-layout v-if="darkenOverlay" fill-height align-center justify-center class="darkOverlay animated8 fadeOut">
    	<v-progress-circular color="white" style="position: relative; top:-70px;"
    		size="200" width="20" indeterminate>
   		</v-progress-circular>
   		<span class="subheading animated6 fadeOut">Reticulating Splines...</span>
   		<!-- <span class="subheading animated10 fadeIn">Aligning Covariance Matrices...</span> -->
	</v-layout>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
data () {
	return {}
},

computed: {
	...mapState({   	darkenOverlay: state => state.ui.darkenOverlay				})
},

methods : {
	...mapMutations([ 	'',					]),
},
}

</script>

<style>

.darkOverlay {
    display: flex;
    flex-direction: column;
    flex: 1;
    z-index: 2;
    position: fixed;
    top: 0;
    width: 100vw;
    background-color: rgba(88, 88, 88, 0.9);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0px;
    padding-top: 10px;
    margin-top: 70px;
    height: 100%;
}

.animated6 {
            -webkit-animation-duration: 1s;animation-duration: 6s;
            -webkit-animation-fill-mode: both;animation-fill-mode: both;
         }

.animated10 {
            -webkit-animation-duration: 1s;animation-duration: 10s;
            -webkit-animation-fill-mode: both;animation-fill-mode: both;
         }

.animated8 {
            -webkit-animation-duration: 1s;animation-duration: 8s;
            -webkit-animation-fill-mode: both;animation-fill-mode: both;
         }
         
         @-webkit-keyframes fadeOut {
            0% {opacity: 1;}
            100% {opacity: 0;}
         }
         
         @keyframes fadeOut {
            0% {opacity: 1;}
            100% {opacity: 0;}
         }
         
         .fadeOut {
            -webkit-animation-name: fadeOut;
            animation-name: fadeOut;
         }

         @-webkit-keyframes fadeIn {
            0% {opacity: 0;}
            100% {opacity: 1;}
         }
         
         @keyframes fadeIn {
            0% {opacity: 0;}
            100% {opacity: 1;}
         }
         
         .fadeIn {
            -webkit-animation-name: fadeIn;
            animation-name: fadeIn;
         }
</style>



// WEBPACK FOOTER //
// src/components/DarkenMapOverlay.vue